export type ClosureDateRangeRow = { from: string; to: string };

export function parseClosureConfigFromApi(raw: unknown): {
	ranges: ClosureDateRangeRow[];
	permanentEnabled: boolean;
	permanentFrom: string;
} {
	const empty = { ranges: [] as ClosureDateRangeRow[], permanentEnabled: false, permanentFrom: "" };
	if (raw == null) return empty;
	let o: unknown = raw;
	if (typeof o === "string") {
		try {
			o = JSON.parse(o);
		} catch {
			return empty;
		}
	}
	if (typeof o !== "object" || !o) return empty;
	const obj = o as {
		dateRanges?: unknown;
		permanentClosure?: { enabled?: boolean; effectiveFrom?: string | null };
	};
	const ranges = Array.isArray(obj.dateRanges)
		? (obj.dateRanges as { from?: string; to?: string }[])
				.map((r) => ({
					from: typeof r?.from === "string" ? r.from.slice(0, 10) : "",
					to: typeof r?.to === "string" ? r.to.slice(0, 10) : "",
				}))
				.filter((r) => r.from && r.to)
		: [];
	const pc = obj.permanentClosure;
	const permanentEnabled = Boolean(pc?.enabled);
	const permanentFrom = typeof pc?.effectiveFrom === "string" ? pc.effectiveFrom.slice(0, 10) : "";
	return { ranges, permanentEnabled, permanentFrom };
}

export function buildClosureExceptionConfigForApi(
	ranges: ClosureDateRangeRow[],
	permanentEnabled: boolean,
	permanentFrom: string,
): { ok: true; value: object | null } | { ok: false; message: string } {
	const cleanedRanges: { from: string; to: string }[] = [];
	for (const r of ranges) {
		const from = String(r.from || "").trim();
		const to = String(r.to || "").trim();
		if (!from && !to) continue;
		if (!from || !to) {
			return {
				ok: false,
				message: "Mỗi khoảng đóng cửa cần đủ ngày bắt đầu và ngày kết thúc (YYYY-MM-DD).",
			};
		}
		if (from > to) {
			return { ok: false, message: "Ngày bắt đầu không được sau ngày kết thúc." };
		}
		cleanedRanges.push({ from, to });
	}
	if (permanentEnabled && !String(permanentFrom || "").trim()) {
		return { ok: false, message: "Đóng cửa vĩnh viễn cần chọn ngày bắt đầu áp dụng." };
	}
	const permanentClosure = {
		enabled: permanentEnabled,
		effectiveFrom: permanentEnabled ? String(permanentFrom).trim() : null,
	};
	if (cleanedRanges.length === 0 && !permanentClosure.enabled) {
		return { ok: true, value: null };
	}
	return {
		ok: true,
		value: {
			dateRanges: cleanedRanges,
			permanentClosure,
		},
	};
}
